function VerticalDivider(index) {
  return (
    <div
      key={index}
      className="min-h-full mx-2 my-0 py-0 w-1 bg-neutral-300 border-1 border-r-2 border-white"
    />
  );
}

export default VerticalDivider;
